import React from "react";
import Table from "../base-table";
import type { TableRef } from "../base-table";
import { getCoreRowModel } from "@tanstack/react-table";
import { CommercialDocument } from "../../graphql/graphql";
import { getInvoicesOrdersTableColumns } from "./InvoicesOrdersTableColumns";

interface InvoicesOrdersTableProps {
  data: CommercialDocument[];
  tableRef: React.Ref<TableRef>;
}

export const InvoicesOrdersTable: React.FC<InvoicesOrdersTableProps> = ({ data, tableRef }) => {
  const columns = React.useMemo(() => getInvoicesOrdersTableColumns(), []);
  const rowModel = getCoreRowModel();

  return (
    <Table
      ref={tableRef}
      data={data}
      columns={columns}
      getCoreRowModel={rowModel}
    />
  );
};


